import styled from 'styled-components';
import { Header } from '../../styles';

export const CopiaxHeader = styled(Header)`
  color: #7c7c7c;
`;
